import { Discipline } from './discipline';

import { disciplinesAll } from '@studyportals/static-domain-data/disciplines/disciplines';
import { disciplineGetSubdisciplines } from '@studyportals/static-domain-data/disciplines/discipline-get-subdisciplines';

class DisciplinePresenter {
	public all(): Promise<readonly Discipline[]> {
		const disciplines = new Array<Discipline>();

		for (const sourceDiscipline of disciplinesAll) {
			disciplines.push(new Discipline(sourceDiscipline.id, sourceDiscipline.name));

			for (const sourceSubdiscipline of disciplineGetSubdisciplines(sourceDiscipline.id)) {
				disciplines.push(new Discipline(sourceSubdiscipline.id, sourceSubdiscipline.name));
			}
		}

		return Promise.resolve(disciplines);
	}

	public async retrieveMultiple(ids: readonly string[]): Promise<readonly Discipline[]> {
		const disciplines = await this.all();
		const disciplinesRelevant = disciplines.filter((d) => ids?.includes(d.id));

		return Promise.resolve(disciplinesRelevant);
	}
}

export default new DisciplinePresenter();
